<template>
    <div class="feedback">
        <div class="topLabel f f-b f--c">
          <span>开发部反馈</span>
          <el-button type="primary" @click="feedbackVisible = true">新增反馈</el-button>
        </div>
        <div class="content">
            <div class="f f-e" style="padding: 8px 24px" >
                <el-select v-model="listParams.sortBy" style="width:140px" @change="customCommentList">
                    <el-option value="asc" label="按时间正序"></el-option>
                    <el-option value="desc" label="按时间倒序"></el-option>
                </el-select>
            </div>
            <div v-for="item in list" :key="item.id" class="f content_item f-b">
                <div class="userInfo">
                    <div class="avatar">
                        <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png">
                    </div>
                    <div>{{item.userName}}</div>
                </div>
                <div class="feedbackContent">
                    <div class="createDate">
                        {{item.createDate | dateFormat}}
                    </div>
                    <div class="font" style="font-weight:bold">{{item.title}}</div>
                    <div class="font">{{item.content}}</div>
                    <div class="imageList f fw-w ">
                        <section v-for="url in JSON.parse(item.imgUrl)" :key="url">
                            <el-image :src="url" :preview-src-list="JSON.parse(item.imgUrl)" v-if="url"></el-image>
                        </section>
                    </div>
                </div>
                <div class="comment fd-c f-e">
                    <div class="f" >
                        <div @click="showDetail(item)" class="pointer" style="margin-right:8px">
                            <i class="el-icon-chat-dot-square"></i>
                            {{item.num}}
                        </div>
                        <div class="pointer">
                            <el-popconfirm title="确定删除此评论吗?" @confirm="deleteComment(item)">
                            <i class="el-icon-delete" slot="reference"></i>
                            </el-popconfirm>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="新增反馈"
            :visible.sync="feedbackVisible"
            width="1000px"
            :before-close="feedbackClose"
            :close-on-click-modal="false">
            <div style="margin-bottom:10px">
                <el-input placeholder="标题" v-model="dialogForm.title" maxlength="250" show-word-limit class="requireInput"></el-input>
            </div>
            <div style="margin-bottom:10px">
                <el-input type="textarea" v-model="dialogForm.content" resize="none" :rows="10" maxlength="2500" show-word-limit></el-input>
            </div>
            <div>
                <div>
                    <span style="margin-right:20px">图片</span>
                    <span style="font-size:12px;color:#8B93A3">最多上传6张</span>
                </div>
                <div class="f fw-w">
                    <el-upload
                        action="https://jsonplaceholder.typicode.com/posts/"
                        list-type="picture-card"
                        :multiple="true"
                        :before-upload="file => imgUploadBefore(file, 'imgUrls')"
                        style="margin: 0 10px 10px 0">
                        <i class="el-icon-circle-plus-outline"></i>
                    </el-upload>
                    <div class="pictureCard" v-for="(imgUrl, index) in imgUrls" :key="imgUrl">
                        <el-image :src="imgUrl" :preview-src-list="imgUrls" style="width:148px;height:148px"></el-image>
                        <i class="el-icon-close" @click="imgUrlDelete(index, 'imgUrls')"></i>
                        <div class="deleteIcon" @click="imgUrlDelete(index, 'imgUrls')"></div>
                    </div>
                    <template v-if="imageLoading">
                        <div style="width:148px;height:148px" v-loading="true" element-loading-text="上传中" v-for="(file, index) in uploadImageList" :key="index"></div>
                    </template>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="feedbackClose">取 消</el-button>
                <el-button type="primary" @click="Submit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible" width="1200px">
            <el-image :preview-src-list="enlargeImages" fit="cover" style="width:100%"></el-image>
        </el-dialog>
        <el-dialog :visible.sync="moreCommentVisible" width="1000px" title="回复" :before-close="moreCommentClose" :close-on-click-modal="false">
            <section class="moreCommentDialog">
                <div class="f" style="margin-bottom:30px">
                    <div class="userInfo">
                        <div class="avatar">
                            <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png">
                        </div>
                        <div style="font-weight:bold">{{moreCommentParentForm.userName}}</div>
                    </div>
                    <div class="feedbackContent">
                        <div class="createDate">
                            {{moreCommentParentForm.createDate | dateFormat}}
                        </div>
                        <div class="font" style="font-weight:bold;">{{moreCommentParentForm.title}}</div>
                        <div class="font">{{moreCommentParentForm.content}}</div>
                        <div class="imageList f fw-w">
                            <section v-for="url in JSON.parse(moreCommentParentForm.imgUrl)" :key="url">
                                <el-image :src="url" :preview-src-list="JSON.parse(moreCommentParentForm.imgUrl)" v-if="url"></el-image>
                            </section>
                        </div>
                    </div>
                </div>
                <div class="sonList f" v-for="item in moreCommentList" :key="item.id">
                    <div class="userInfo">
                        <div class="smallAvatar">
                            <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png">
                        </div>
                    </div>
                    <div class="feedbackContent">
                        <div class="f">
                            <span style="font-weight:bold;margin-right:16px">{{item.userName}}</span>
                            <span style="color:#8B93A3;font-size:12px">{{item.createDate | dateFormat}}</span>
                        </div>
                        <div class="font">{{item.content}}</div>
                        <div class="imageListSmall f fw-w">
                            <section v-for="url in JSON.parse(item.imgUrl)" :key="url">
                                <el-image :src="url" :preview-src-list="JSON.parse(item.imgUrl)" v-if="url"></el-image>
                            </section>
                        </div>
                    </div>
                </div>
                <div class="p-r" style="margin-top:60px">
                    <el-input type="textarea" v-model="moreCommentAddContent" resize="none" :rows="10" placeholder="请输入" ></el-input>
                    <div class="moreCommentBtn f-b f--c">
                        <div class="f fw-w">
                            <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture"
                                :multiple="true"
                                :before-upload="file => imgUploadBefore(file, 'moreCommentUrls')"
                                style="margin: 0 10px 0 0">
                                <el-button size="small" type="text">点击上传</el-button>
                            </el-upload>
                            <template v-if="imageLoading">
                                <div style="width:28px;height:28px" v-loading="true" v-for="(file, index) in uploadImageList" :key="index"></div>
                            </template>
                            <template v-else>
                                <div class="moreCommentPic pictureCard" v-for="(imgUrl, index) in moreCommentUrls" :key="imgUrl">
                                    <el-image :src="imgUrl" :preview-src-list="moreCommentUrls" style="width:28px;height:28px"></el-image>
                                    <i class="el-icon-close" @click="imgUrlDelete(index, 'moreCommentUrls')"></i>
                                    <div class="deleteIcon" @click="imgUrlDelete(index, 'moreCommentUrls')"></div>
                                </div>
                            </template>
                        </div>
                        <el-button type="primary" @click="moreCommentSubmit">发送</el-button>
                    </div>
                </div>
            </section>
        </el-dialog>
    </div>
</template>

<script>
import API from '@/api'
import moment from 'moment'
export default {
    props: {
        productCustomId: {
            type: String,
            default: ''
        }
    },
    filters: {
        dateFormat(value) {
            return moment(value).format('YYYY-MM-DD HH:mm')
        }
    },
    data() {
        return {
            dialogForm: {
                productCustomId: undefined,
                parentId: undefined,
                title: undefined,
                content: undefined,
                imgUrl: undefined
            },
            feedbackVisible: false,
            imgUrls: [],
            imageSignValue: undefined,
            uploadImageTimer: null,
            dialogVisible: false,
            dialogImageUrl: '',
            listParams: {
                productCustomId: undefined,
                sortBy: 'asc',
                pageSize: 10,
                pageNumber: 1
            },
            list: [],
            uploadImageList: [],
            moreCommentParentForm: {
                imgUrl: '[]'
            },
            moreCommentVisible: false,
            moreCommentAddForm: null,
            moreCommentUrls: [],
            moreCommentAddContent: undefined,
            moreCommentList: [],
            enlargeImages: [],
            imageLoading: false
        }
    },
    async created() {
        this.customCommentList()
        let imageSignValue = await API.customProductGetSignValue({ directory: 'customProduct/' })
        this.imageSignValue = imageSignValue.data
    },
    methods: {
        // 开发部反馈
        customCommentList() {
            const params = {
                ...this.listParams,
                productCustomId: this.productCustomId,
                pageSize: 100
            }
            API.customCommentList(params).then(res=>{
                this.list = res.data ? res.data.list : []
            })
        },
        feedbackClose() {
            this.feedbackVisible = false
            this.dialogForm = {
                productCustomId: undefined,
                parentId: undefined,
                title: undefined,
                content: undefined,
                imgUrl: undefined
            }
            this.imgUrls = []
            this.customCommentList()
        },
        Submit() {
            const params = {...this.dialogForm}
            if(!params.title) return this.$message.error('请填写标题')
            params.productCustomId = this.productCustomId
            params.parentId = 0
            params.imgUrl = this.imgUrls.length ? this.imgUrls.join(',') : ''
            API.customCommentSave(params).then(()=>{
                this.$message.success('评论成功')
                this.feedbackClose()
                this.customCommentList()
            })
        },
        imgUploadBefore(file, arrString) {
            if (['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
                if ((this[arrString].length + this.uploadImageList.length) < 6) {
                    this.uploadImageList.push(file)
                    if (this.uploadImageTimer) {
                            clearTimeout(this.uploadImageTimer)
                        }
                        this.uploadImageTimer = setTimeout(() => {
                            this.imgUploadHandle(arrString)
                        }, 100)
                    } else {
                        this.$message.error(`最多上传6张图片`)
                        this.uploadImageList = []
                    }
                } else {
                    this.$message.error('只能上传图片')
                }
            return false
        },
        imgUploadHandle(arrString) {
            this.imageLoading = true
            const that = this
            const imgFormData = new FormData()
            imgFormData.append('directory', 'customProduct/')
            imgFormData.append('signValue', that.imageSignValue)
            this.uploadImageList.forEach(e=>imgFormData.append('fileList', e))
            API.customProductUploadFile(imgFormData).then(res => {
                that[arrString] = [...that[arrString], ...res.data.split(',')]
            }).finally(()=>{
                that.uploadImageList = []
                this.imageLoading = false
                that.uploadImageList = []
            })
        },
        imgUrlDelete(index, arrString) {
            this[arrString].splice(index, 1)
        },
        imgVisit(imgUrls) {
            this.enlargeImages = imgUrls
            this.dialogVisible = true
        },
        showDetail(item) {
            this.moreCommentParentForm = item
            API.customCommentDetail(item.id).then(res=>{
                this.moreCommentList = res.data
                this.moreCommentVisible = true
            })
        },
        moreCommentSubmit() {
            const params = {
                content: this.moreCommentAddContent,
                productCustomId: this.productCustomId,
                parentId: this.moreCommentParentForm.id
            }
            params.imgUrl = this.moreCommentUrls.join(',')
            if(!params.content && !params.imgUrl.length) return this.$message.error('内容或者附件必须有其中一项')
            API.customCommentSave(params).then(()=>{
                this.$message.success('评论成功')
                this.moreCommentClose()
                this.customCommentList()
            })
        },
        moreCommentClose() {
            this.moreCommentAddForm = null
            this.moreCommentAddContent = undefined
            this.moreCommentParentForm = {
                imgUrl: '[]'
            }
            this.moreCommentUrls = []
            this.moreCommentVisible = false
        },
        deleteComment(item) {
            API.customCommentDelete(item.id).then(()=>{
                this.$message.success('操作成功')
                this.customCommentList()
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.feedback{
    flex:3;
    background-color: #fff;
}
.topLabel{
    padding: 14px 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.content{
    .content_item{
        margin-bottom: 24px;
    }
}
.userInfo {
    margin-left: 14px;
    margin-right: 8px;
    .avatar{
        padding: 0 16px 8px;
        >img{
            height: 38px;
            width: 38px;
            display: block;
            border-radius: 50%;
            // margin-right: 10px;
        }
    }
    .smallAvatar{
        padding: 0 12px 8px;
        >img{
            height: 30px;
            width: 30px;
            display: block;
            border-radius: 50%;
        }
    }
}
.feedbackContent{
    flex: 1;
    .createDate{
        padding: 4px 0;
        color: #8B93A3;
        font-size: 12px;
    }
    .font {
        line-height: 50px;
    }
    .imageList {
        /deep/.el-image{
            display: block;
            height: 84px;
            width: 84px;
            margin-right: 12px;
        }
        // img{
        //     display: block;
        //     height: 84px;
        //     width: 84px;
        //     margin-right: 12px;
        // }
    }
    .imageListSmall {
        /deep/.el-image{
            display: block;
            height: 40px;
            width: 40px;
            margin-right: 12px;
        }
    }
}
.comment {
    width: 60px;
}
.moreCommentDialog {
    textarea{
        background-color: #FAFAFA;
        border-radius: 6px;
    }
    .moreCommentBtn{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 16px;
        height: 60px;
        .moreCommentPic {
            width: 28px !important;
            height: 28px !important;
            margin-bottom: 0px !important;
            .deleteIcon {
                width: 12px !important;
                height: 12px !important;
            }
            .el-icon-close{
                font-size: 10px;
                top: 0px !important;
                right: 0px !important;
            }
            img{
                margin-bottom: 0px !important;
            }
        }
    }
    .sonList{
        margin-bottom: 14px;
    }
}
.pictureCard {
    margin: 0 10px 10px 0;
    position: relative;
    width: 148px;
    height: 148px;
    border-radius: 6px;
    border: 1px solid #CDD4DD;
    cursor: pointer;
    >img {
        height: 100%;
        width: 100%;
        border-radius: 6px;
    }
    .deleteIcon {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        border-radius: 2px 6px 2px 30px;
        background: rgba(71, 71, 71, 0.6);
        transition: background .5s 0s;
        cursor: pointer;
    }
    .deleteIcon:hover {
        background: rgba(19, 18, 18, 0.6);
    }
    .el-icon-close {
        position: absolute;
        top: 6px;
        right: 6px;
        color: #fff;
        cursor: pointer;
        z-index: 10;
    }
    .el-icon-close:hover ~ .deleteIcon {
        background: rgba(19, 18, 18, 0.6);
    }
}
.requireLabel{
    position: relative;
}
.requireLabel::after{
    content: '*';
    color: red;
    position: absolute;
    left: -2px;
    top: 0px;
}
.requireInput{
    position: relative;
}
.requireInput::after{
    content: '*';
    color: red;
    position: absolute;
    left: 6px;
    top: 10px;
}
</style>
